/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataClass } from '../models/DataClass';

export class OverrideDataClassificationsRequest {
  /**
  * List of data classes to set.
  */
  'dataClasses'?: Array<DataClass>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dataClasses",
      "baseName": "dataClasses",
      "type": "Array<DataClass>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return OverrideDataClassificationsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

